module.exports = __webpack_public_path__ + "media/01_HOMEPAGE 2.webm";